































































































import Connection from '@/models/Connection';
import Node from '@/models/Node';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit, Prop, Watch } from 'vue-property-decorator';

enum Stage
{
    Prepare,
    Generating,
    Quiz,
    Checking,
    Correct
}

@Component
export default class ProtoQuizGenerator extends Vue 
{
    @Prop(Array) readonly events! : Node[];
    @Prop(Array) readonly connections! : Connection[];

    get filteredEvents()
    {
        return this.events;
    }

    get filteredConnections()
    {
        return this.connections;
    }

    Stage = Stage;
    currentStage = Stage.Prepare;

    generatedQuiz = "";
    correctionText = "";
    feedback = "";
    hinting = false;

    get formattedQuiz()
    {
        if (!this.generatedQuiz) return '';
        return this.generatedQuiz
            .replace(/\{([^|]+?)\|[^}]+?\}/g, (_, incorrect) => this.hinting ? `<span class="highlighted">${incorrect.trim()}</span>` : `${incorrect.trim()}`)
            // .replace(/\n/g, '<br>')
        ;
    }

    initializeGenerateRequest(events: Node[], connections: Connection[])
    {
        const evs = events.map(a=>({
            id: a.nodeid,
            title: a.name,
            description: a.description,
            start: a.dateStart,
            end: a.dateEnd
        }));

        evs.sort((a, b) => a.start.getTime() - b.start.getTime());
        const conns = connections.map(a=>({
            A: a.nodeid1,
            B: a.nodeid2,
            Description: a.description
        }));

        return {
            events: evs,
            connections: conns
        };
    }

    async generate()
    {
        this.hinting = false;
        this.generatedQuiz = "";
        this.correctionText = "";
        this.feedback = "";
        this.currentStage = Stage.Generating;
        try
        {
            const res = await this.$http.post<{quizQuestion: string}>('quiz/generate', this.initializeGenerateRequest(this.filteredEvents, this.filteredConnections));
            this.generatedQuiz = res.data.quizQuestion;
        }
        catch (e)
        {
            alert('Failed to generate quiz.  See console for details.');
            console.error(e);
            this.currentStage = Stage.Prepare;
            return;
        }

        this.currentStage = Stage.Quiz;
    }

    initializeCheckRequest(quiz: string, answer: string)
    {
        return {
            encodedQuiz: quiz,
            answer
        };
    }

    async submitCorrection()
    {
        this.currentStage = Stage.Checking;
        const request = this.initializeCheckRequest(this.generatedQuiz, this.correctionText);
        try
        {
            const resp = await this.$http.post<{result: string}>('quiz/check', request);
            if (resp.data.result === "Correct")
            {
                this.currentStage = Stage.Correct;
            }
            else
            {
                alert('The quiz was incorrect.  Please try again.');
                this.currentStage = Stage.Quiz;
                this.feedback = resp.data.result;
            }
        }
        catch (e)
        {
            alert('Failed to check quiz.  See console for details.');
            console.error(e);
            this.currentStage = Stage.Quiz;
        }
    }
}
